import { render, staticRenderFns } from "./SmtAdminConsent.vue?vue&type=template&id=0f2524d1&scoped=true"
import script from "./SmtAdminConsent.vue?vue&type=script&lang=js"
export * from "./SmtAdminConsent.vue?vue&type=script&lang=js"
import style0 from "./SmtAdminConsent.vue?vue&type=style&index=0&id=0f2524d1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2524d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2524d1')) {
      api.createRecord('0f2524d1', component.options)
    } else {
      api.reload('0f2524d1', component.options)
    }
    module.hot.accept("./SmtAdminConsent.vue?vue&type=template&id=0f2524d1&scoped=true", function () {
      api.rerender('0f2524d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/SmtAdminConsent.vue"
export default component.exports